@if (showLoader()) {
<app-loader></app-loader>
}
<div class="w-100">
  @if (gridConfig) {
  <div class="w-100" [style.height.px]="containerHeight">
    <inavista-grid #msGrid class="so-popup-grid"
        [config]="gridConfig"
        (hyperlinkClick)="onHyperlinkClick($event)"
        (exportRequested)="onExportRequested()" />
  </div>
  }
</div>

@if (showAdjustmentOrderPopup()) {
<app-ms-dynamic-popup
    tabName="details"
    pageId="PG0000149"
    [pageType]='"Popup"'
    [orderId]="popupData.adjustmentOrderNumber"
    [data]="popupData"
    [showComments]="false"
    (onClose)="showAdjustmentOrderPopup.set(false)"
></app-ms-dynamic-popup>
}

@if (linkedPopupData()) {
<app-linked-popup-opener
    [data]="linkedPopupData()"
    (onPopupClose)="linkedPopupData.set(null)"
></app-linked-popup-opener>
}
